import ECSEditorContext from 'contexts/ECSEditorContext';
import ECSWorldContext from 'contexts/ECSWorldContext';
import UpdateTextInteraction from 'editor/components/interactions/UpdateTextInteraction';
import KeyboardEvents from 'editor/components/KeyboardEvents';
import { FC, useContext, useEffect } from 'react';

const ECSKeyboardEvents: FC = () => {
  const { tool } = useContext(ECSEditorContext);
  const world = useContext(ECSWorldContext);

  useEffect(() => {
    const keyboardEvents = new KeyboardEvents();

    keyboardEvents.on('keydown', ({ evt }) => {
      world.locateAll([UpdateTextInteraction]).forEach((entity) => {
        const interaction = entity.get<UpdateTextInteraction>(
          UpdateTextInteraction
        );

        switch (evt.key) {
          case 'Escape':
            // Right now blurring, which creates a markup. Should this just cancel?
            interaction.element.blur();
            break;
          default:
        }
      });
    });

    const keyboardEventsEntity = world
      .createEntity()
      .add(keyboardEvents)
      .add(tool);

    return () => {
      keyboardEventsEntity.destroy();
    };
  }, []);

  return null;
};

export default ECSKeyboardEvents;
